import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { CurrencyConversionExchangeRatesProfile } from 'lumen/models';

interface SettingsCurrencyConversionTablesCellsTdTitleSignature {
  Args: {
    cellData: string;
    column: {
      isReadOnly: boolean;
    };
    row: {
      [key: string]: unknown;
      profile: CurrencyConversionExchangeRatesProfile;
    };
  };
}

export default class SettingsCurrencyConversionTablesCellsTdTitle extends Component<SettingsCurrencyConversionTablesCellsTdTitleSignature> {
  @service declare intl: Services['intl'];

  get badgeText(): string {
    if (this.showExchangeRateMissingWarning) {
      return this.intl.t('settings.currency_conversion.exchange_rate_missing');
    }
    if (this.showMissingCurrencyWarning) {
      return this.intl.t('settings.currency_conversion.currency_missing');
    }

    return '';
  }

  get hasNoExchangeRates(): boolean {
    return this.args.row.profile.hasNoExchangeRates;
  }

  get isMissingPortfolioCurrencies(): boolean {
    return this.args.row.profile.isMissingPortfolioCurrencies;
  }

  get showExchangeRateMissingWarning(): boolean {
    // when all portfolio currency are missing from the profile rates array.
    return this.args.row.profile.isMissingAllPortfolioCurrencies;
  }

  get showMissingCurrencyWarning(): boolean {
    // Entire currency is missing (either the portfolio has 1 currency (used as base currency) or a new currency is required by the portfolio)
    return this.isMissingPortfolioCurrencies || this.hasNoExchangeRates;
  }

  get showWarningBadge(): boolean {
    return this.isMissingPortfolioCurrencies || this.hasNoExchangeRates;
  }

  <template>
    <div class="flex items-center gap-100">
      <p class="text-200--regular">{{@cellData}}</p>

      {{#if this.showWarningBadge}}
        <PrismBadge @label={{this.badgeText}} @type="warning" />
      {{/if}}
    </div>
  </template>
}
